import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lib-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToastContainerComponent {}
